import { Inbox } from "lucide-react";
import { Link } from "react-router-dom";
import { cn } from "@shared-kernel/primary/shared/shadcn/utils/utils";
import { Empty, EmptyHeader, EmptyMedia, EmptyTitle, EmptyDescription, EmptyContent } from "@shared-kernel/primary/shared/shadcn/ui/empty";
import { Button } from "@shared-kernel/primary/shared/shadcn/ui/button";
import type { EmptyStateProps } from "../types";

const DEFAULT_TITLE = "Aucune donnée";
const DEFAULT_DESCRIPTION = "Il n'y a pas encore de données à afficher.";

export const EmptyState = ({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  cta,
  ctaLink,
  icon,
  className,
}: EmptyStateProps) => {
  return (
    <Empty className={cn("border-0", className)}>
      <EmptyHeader>
        <EmptyMedia variant="icon">{icon ?? <Inbox />}</EmptyMedia>
        <EmptyTitle>{title}</EmptyTitle>
        <EmptyDescription>{description}</EmptyDescription>
      </EmptyHeader>
      {cta && (
        <EmptyContent>
          {ctaLink ? (
            <Button asChild size="sm">
              <Link to={ctaLink}>{cta}</Link>
            </Button>
          ) : (
            <span className="text-muted-foreground">{cta}</span>
          )}
        </EmptyContent>
      )}
    </Empty>
  );
};
